const {
  APP_ENV,
  APP_URL,
  FILESTACK_PUBLIC_KEY,
  NODE_ENV,
  OAUTH_SERVICE_URL,
  SENTRY_PUBLIC_KEY,
  SITE_ANALYTICS_WRITEKEY,
  RECAPTCHA_PUBLIC_KEY = ''
} = process.env

// Read the app version from the html so that it doesn't cause the main bundle
// to be cache busted on every deploy
const APP_VERSION = document.body.dataset.version

export {
  APP_ENV,
  APP_URL,
  APP_VERSION,
  FILESTACK_PUBLIC_KEY,
  NODE_ENV,
  OAUTH_SERVICE_URL,
  SENTRY_PUBLIC_KEY,
  SITE_ANALYTICS_WRITEKEY,
  RECAPTCHA_PUBLIC_KEY
}
